import api from "@/plugins/api/EntryPoint";

export default {
  async getPaymentUrl(params, callBackFn) {
    return await api.post(`easy-pay/payment`, params, callBackFn);
  },
  async getClusterPayment(params, callBackFn) {
    return await api.post(`easy-pay/payment-cluster`, params, callBackFn);
  },
  async saveCard(params, callBackFn) {
    return await api.post(`easy-pay/save-card`, params, callBackFn);
  },
  async getEasyPayCardsList(callBackFn) {
    await api.get(`easy-pay/saved-card-list`, callBackFn);
  },
  async getEasyPaySaveCardsPage(callBackFn) {
    await api.post(`easy-pay/3d-secure-url-alt`, {}, callBackFn);
  },
  async deleteCard(params, callBackFn) {
    return await api.post(`easy-pay/delete-card`, params, callBackFn);
  },
};
